/*
 * Novicell master
 *  Author: APN modified by DLA
 *  Use this file to call functions in other files, on document ready, window.resize etc.
 *  ------
 * Dependencies: jquery, novicell.js, other files with awesome functions.
 *  Usage: $(function () {
 *              Kosangas.slider.heroSlider($('.owl-carousel'));
 *         }); // Document ready end
 */

var novicell = novicell || {};
var kosan = kosan || {};

// Document ready
$(function () {
    templatePolyfill();
    // Only include Novicell functions that you use!
    novicell.responsive.init();
    //novicell.map.init();
    // novicell.adjustFigureImage.init();
    // novicell.lazyload.content();
    // novicell.lazyload.image();

    // Call new functions here like this:
    //Kosangas.slider.heroSlider($('.owl-carousel'));

    novicell.responsiveLazyloadImage.image();
    novicell.embed.loadEmbeds();

    // kosan.searchNav.init();
    // kosan.header.init();
    // kosan.accordion.init();
    // kosan.tileboxes.init(); 
    kosan.maps.init();
    kosan.swiperSection.init();
    svg4everybody(); // Fix SVG spritemap in IE/Edge

    //maps
    $('.map-overlay').on('mouseover', function () {
        $(".map-overlay").fadeOut();
    });
    $('.map-overlay').on('click', function () {
        $(".map-overlay").fadeOut();
    });
    $(window).scroll(function () {
        $(".map-overlay").fadeIn();
    });

    //show column background images
    $('[data-background-image]').each(function (b, a) {
        $(a).css("background-image", 'url(' + $(a).data('background-image') + "?width=1950&height=250&quality=75&mode=crop&format=jpg" + ')');
        $(a).css("background-repeat", "no-repeat");
        $(a).removeAttr('data-background-image');
    });

    if (!navigator.onLine) {
        //console.warn('Website is online?', navigator.onLine);

        var input = document.querySelector('#js-mapsearch-input');
        var placeholderText = input.getAttribute('data-placeholder-text');
        var alertText = input.getAttribute('data-alert-text');

        input.setAttribute('readonly', 'readonly');
        input.setAttribute('placeholder', placeholderText);
        document.querySelector('#js-mapsearch').style.pointerEvents = "none";
        document.querySelector('.mapbuilder').style.display = "none";
        document.querySelector('#js-map-container').classList.add('map-container--offline');
    }

    function showRefreshUI(registration) {
        // TODO: Display a toast or refresh UI.

            if (!registration.waiting) {
                // Just to ensure registration.waiting is available before
                // calling postMessage()
                return;
            }

            registration.waiting.postMessage('skipWaiting');

    };

    function onNewServiceWorker(registration, callback) {
        if (registration.waiting) {
            // SW is waiting to activate. Can occur if multiple clients open and
            // one of the clients is refreshed.
            return callback();
        }

        function listenInstalledStateChange() {
            registration.installing.addEventListener('statechange', function (event) {
                if (event.target.state === 'installed') {
                    // A new service worker is available, inform the user
                    callback();
                }
            });
        };

        if (registration.installing) {
            return listenInstalledStateChange();
        }

        // We are currently controlled so a new SW may be found...
        // Add a listener in case a new SW is found,
        registration.addEventListener('updatefound', listenInstalledStateChange);
    }

    window.addEventListener('load', function () {
        navigator.serviceWorker.register('/sw.js')
            .then(function (registration) {
                // Track updates to the Service Worker.
                if (!navigator.serviceWorker.controller) {
                    // The window client isn't currently controlled so it's a new service
                    // worker that will activate immediately
                    return;
                }

                // When the user asks to refresh the UI, we'll need to reload the window
                var preventDevToolsReloadLoop;
                navigator.serviceWorker.addEventListener('controllerchange', function (event) {
                    // Ensure refresh is only called once.
                    // This works around a bug in "force update on reload".
                    if (preventDevToolsReloadLoop) return;
                    preventDevToolsReloadLoop = true;
                    console.log('Controller loaded');
                    window.location.reload();
                });

                onNewServiceWorker(registration, function () {
                    showRefreshUI(registration);
                });
            });
    });

}); // Document ready end


/*
 *  Use the following if needed
 */

function templatePolyfill() {
    if ('content' in document.createElement('template')) {
        return false;
    }

    var templates = document.getElementsByTagName('template');
    var plateLen = templates.length;

    for (var x = 0; x < plateLen; ++x) {
        var template = templates[x];
        var content = template.childNodes;
        var fragment = document.createDocumentFragment();

        while (content[0]) {
            fragment.appendChild(content[0]);
        }

        template.content = fragment;
    }
}

// Window resize
$(window).smartresize(function (e) {
    // call functions here
    novicell.responsiveLazyloadImage.onResize();
    novicell.embed.onResize();
}); // Window resize

// Window scroll
$(window).smartscroll(function (e) {
    // call functions here
    if ($('.responsiveLazyload').length > 0) {
        novicell.responsiveLazyloadImage.image();
    }
    if ($('.embed-media-item').length > 0) {
        novicell.embed.loadEmbeds();
    }
}); // Window scroll

function containsSRC() {

    var getIframes = document.querySelectorAll("iframe");
    for (var i = 0; i < getIframes.length; i++) {
        var iframe = getIframes[i];

        var cookie = getCookie("OptanonConsent") || "";
        if (cookie && cookie.includes('C0001%3A1%2CC0004%3A1')) {
            var cookieMessage = document.querySelectorAll('.cookieconsent-optout-statistics');
            for (var k = 0; k < cookieMessage.length; k++) {
                var message = cookieMessage[k];
                message.classList.add('hidden');
            }

             break; 
        }
    }
}
window.onload = containsSRC();


document.querySelector("body").addEventListener("click", function (e) {
    if (e.target.id === "accept-recommended-btn-handler" || e.target.classList.contains("save-preference-btn-handler") || e.target.id === "onetrust-accept-btn-handler" || e.target.id === "onetrust-reject-all-handler") {
        window.location.reload();
    }
});